"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidTimetableRulesByDay = getValidTimetableRulesByDay;
var main_api_1 = require("../main-api");
function getValidTimetableRulesByDay(timezonedDate, timetable) {
    var validTimetableRules = [];
    var weekDay = timezonedDate.isoWeekday();
    for (var _i = 0, timetable_1 = timetable; _i < timetable_1.length; _i++) {
        var rule = timetable_1[_i];
        if (rule.days.findIndex(function (day) { return weekDay === day; }) < 0) {
            continue;
        }
        if (rule.type === main_api_1.TimetableRuleType.RESTRICTION) {
            return []; // RESTRICTION takes priority over all ALLOWANCE rules
        }
        if (rule.type === main_api_1.TimetableRuleType.ALLOWANCE) {
            validTimetableRules.push(rule);
        }
    }
    return validTimetableRules;
}
//# sourceMappingURL=getValidTimetableRulesByDay.js.map